import React from 'react';
import PropTypes from 'prop-types';

import Status from '@components/asset/modal/tabs/workflow/asset_details/status';
import Availability from '@components/asset/modal/tabs/workflow/asset_details/availability';
import Approval from '@components/asset/modal/tabs/workflow/asset_details/approval';
import { Collection } from '@helpers/show_page_helpers';

const AssetDetails = (props) => {
  const {
    approver,
    asset,
    displayAssetStatus,
    retrieveAsset,
    setAsset,
    updateFetchControllers
  } = props;

  return (
    <section className="asset-details">
      {displayAssetStatus && (
        <Status
          asset={asset}
        />
      )}
      {(BFG.context.hasFeature('asset_availability') && !Collection.key) && (
        <Availability
          asset={asset}
          retrieveAsset={retrieveAsset}
        />
      )}
      {(BFG.context.hasFeature('asset_approvals') && approver) && (
        <Approval
          asset={asset}
          setAsset={setAsset}
          updateFetchControllers={updateFetchControllers}
        />
      )}
    </section>
  );
};

AssetDetails.propTypes = {
  approver: PropTypes.bool.isRequired,
  asset: PropTypes.shape({
    id: PropTypes.string,
    attributes: PropTypes.shape({
      activeCdnTracers: PropTypes.number,
      approved: PropTypes.bool,
      availability: PropTypes.string,
      availability_end: PropTypes.string,
      availability_start: PropTypes.string,
    })
  }).isRequired,
  displayAssetStatus: PropTypes.bool.isRequired,
  retrieveAsset: PropTypes.func.isRequired,
  setAsset: PropTypes.func.isRequired,
  updateFetchControllers: PropTypes.func.isRequired,
};

export default AssetDetails;
